"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var EditorTypes_1 = require("../../EditorTypes");
var WidgetManager_1 = require("../../WidgetManager");
var TableColumnManager = __importStar(require("./TableColumnManager"));
var TableSelectionManager_1 = require("./TableSelectionManager");
var TableStyleStore_1 = require("./TableStyleStore");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var TableWidgetToolbar_1 = require("./TableWidgetToolbar");
var TableWidgetContext_1 = require("./TableWidgetContext");
var WidgetToolbarPositioning_1 = require("../WidgetToolbarPositioning");
var PlaceholderContext_1 = __importDefault(require("Project/QwilrEditor/Placeholder/PlaceholderContext"));
var AgreementSchema_1 = require("Project/QwilrEditor/Schemas/AgreementSchema");
var TableWidget = (function (_super) {
    __extends(TableWidget, _super);
    function TableWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.resizeColumnIndex = null;
        _this.tableElem = null;
        _this.readyToRenderWholeToolbar = false;
        _this.hoveredColumnForDeletionIdx = undefined;
        _this.onMouseDown = function (event) {
            _this.selectionManager.onEvent(event);
        };
        _this.routeMouseEvent = function (event) {
            if (_this.resizeColumnIndex != null) {
                return;
            }
            _this.selectionManager.onEvent(event);
        };
        _this.startResizingColumn = function (border) {
            return function (event) {
                _this.boundingBox = _this.tableElem.getBoundingClientRect();
                event.preventDefault();
                (0, mobx_1.runInAction)(function () {
                    _this.resizeColumnIndex = border;
                    _this.columnBorders = lodash_1.default.cloneDeep(_this.props.columnBorders);
                });
                document.addEventListener("mousemove", _this.resizeColumnDebounced);
                document.addEventListener("mouseup", _this.stopResizing);
            };
        };
        _this.resizeColumn = function (event) {
            event.preventDefault();
            var relX = event.clientX - _this.boundingBox.x;
            var newPosition = (relX / _this.boundingBox.width) * 100;
            var resizer = TableColumnManager.resizeColumnSingle;
            if (_this.props.usingFeature(FeatureFlag_1.FeatureFlag.NewEditorFancyColumns)) {
                resizer = TableColumnManager.resizeColumnsRight;
            }
            resizer = resizer.bind(TableColumnManager);
            var newBorders = resizer(_this.resizeColumnIndex, newPosition, _this.columnBorders);
            _this.columnBorders = newBorders;
        };
        _this.stopResizing = function () {
            _this.resizeColumnIndex = null;
            document.removeEventListener("mousemove", _this.resizeColumnDebounced);
            document.removeEventListener("mouseup", _this.stopResizing);
            _this.saveColumnSize();
        };
        _this.reselectText = function (event) {
            if (document.activeElement.type == "text") {
                return;
            }
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                eventType: "reselection",
            }));
        };
        _this.deleteTable = function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.DeleteTable,
                path: _this.props.widgetManager.getPath(_this.props.element),
            }));
        };
        _this.saveColumnSize = function (columnBorders) {
            if (!columnBorders) {
                columnBorders = _this.props.columnBorders;
            }
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.ResizeColumns,
                path: _this.props.widgetManager.getPath(_this.props.element),
                columnBorders: lodash_1.default.cloneDeep(_this.columnBorders),
            }));
        };
        _this.setSelection = function (anchorIndex, focusIndex) {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.SelectionChange,
                path: _this.props.widgetManager.getPath(_this.props.element),
                selection: {
                    anchorCell: anchorIndex,
                    focusCell: focusIndex,
                },
            }));
        };
        _this.onMouseLeave = function (event) {
            if (event.buttons === 1) {
                _this.selectionManager.onEvent(event);
            }
        };
        _this.hasSelectedCells = function () {
            return (!!_this.props.selection && !!_this.props.selection.selectedCells && _this.props.selection.selectedCells.length > 0);
        };
        _this.myProps = function () {
            return _this.props;
        };
        _this.startHoveringOnDelete = function () {
            _this.isHoveringOnDelete = true;
        };
        _this.stopHoveringOnDelete = function () {
            _this.isHoveringOnDelete = false;
        };
        _this.resizeColumnDebounced = lodash_1.default.debounce(_this.resizeColumn, 0);
        _this.rows = props.rows;
        _this.columns = props.columns;
        _this.columnBorders = lodash_1.default.cloneDeep(props.columnBorders);
        _this.resizeColumnIndex = null;
        _this.isHoveringOnDelete = false;
        _this.selectionManager = new TableSelectionManager_1.TableSelectionManager(_this.myProps, _this.setSelection);
        _this.styleStore = new TableStyleStore_1.TableStyleStore(props.brandStore, props.blockStore.blockStyleStore);
        var normalizedColumnBorders = TableColumnManager.normalizeColumnBorders(props.columns, props.columnBorders);
        if (normalizedColumnBorders != props.columnBorders) {
            _this.saveColumnSize(normalizedColumnBorders);
        }
        return _this;
    }
    TableWidget.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.rows != this.props.rows || prevProps.columns != this.props.columns) {
            (0, mobx_1.runInAction)(function () {
                _this.rows = _this.props.rows;
                _this.columns = _this.props.columns;
                _this.columnBorders = lodash_1.default.cloneDeep(_this.props.columnBorders);
            });
        }
        if (!this.props.isSelected && this.hasSelectedCells()) {
            this.setSelection(null, null);
        }
    };
    TableWidget.prototype.componentDidMount = function () {
        this.readyToRenderWholeToolbar = true;
    };
    TableWidget.prototype.render = function () {
        var _this = this;
        var className = "table-widget__table qwilr-table";
        var contentEditable = true;
        if (this.hasSelectedCells()) {
            className += " table-widget__table--no-select";
            contentEditable = false;
        }
        if (this.selectionManager.areAllCellsSelected()) {
            className += " table-widget__table--all-selected";
        }
        var widgetClassName = "table-widget project-block__block-element";
        if (this.isHoveringOnDelete) {
            widgetClassName += " table-widget--delete-hover";
        }
        var widgetManager = this.props.widgetManager;
        return (react_1.default.createElement("div", __assign({ className: widgetClassName }, this.props.attributes, { onMouseLeave: this.onMouseLeave }),
            react_1.default.createElement("table", { className: className, onMouseDown: this.onMouseDown, onMouseMove: this.routeMouseEvent, onMouseUp: this.routeMouseEvent, ref: function (node) {
                    _this.tableElem = node;
                } },
                react_1.default.createElement("colgroup", { contentEditable: false }, this.renderColumnWidths()),
                react_1.default.createElement("tbody", null,
                    react_1.default.createElement(TableWidgetContext_1.TableWidgetContext.Provider, { value: {
                            data: {
                                columns: this.props.columns,
                                rows: this.props.element.children.length - 1,
                            },
                            hasSelectedCells: this.hasSelectedCells(),
                            selection: this.props.selection,
                            tableSelectionManager: this.selectionManager,
                            tableStyleStore: this.styleStore,
                            cellsAreEditable: widgetManager.canEdit && contentEditable,
                            actions: {
                                addRow: function (_a) {
                                    var referenceRow = _a.referenceRow, direction = _a.direction, type = _a.type;
                                    if (type === "regular") {
                                        _this.addRow(referenceRow + 1, direction)();
                                    }
                                    else {
                                        _this.addRepeatingRow(referenceRow + 1, direction)();
                                    }
                                },
                                deleteRow: function (row) {
                                    _this.deleteRows([row])();
                                },
                                addColumn: function (column, direction) {
                                    _this.addColumn(column + (direction === "before" ? 0 : 1))();
                                },
                                deleteColumn: function (column) {
                                    _this.deleteColumns([column])();
                                    _this.hoveredColumnForDeletionIdx = undefined;
                                },
                                hoverColumnForDeletion: function (currentColumnIndex) {
                                    (0, mobx_1.runInAction)(function () {
                                        _this.hoveredColumnForDeletionIdx = currentColumnIndex;
                                    });
                                },
                            },
                            enableRepeatingTableRows: this.props.enableRepeatingTableRows,
                            hoveredColumnForDeletionIdx: this.hoveredColumnForDeletionIdx,
                            isResizingColumns: this.resizeColumnIndex != undefined,
                        } },
                        react_1.default.createElement(PlaceholderContext_1.default, { placeholders: { heading1: null, heading2: null, paragraph: null } }, this.props.children)))),
            widgetManager.canEdit && (react_1.default.createElement("div", { contentEditable: false },
                this.renderSizeModifiers(),
                this.renderTableToolbar(),
                this.renderSelector()))));
    };
    TableWidget.prototype.renderColumnWidths = function () {
        var columns = [];
        for (var i = 0; i < this.props.columns; i++) {
            var width = this.getColumnBorder(i + 1) - this.getColumnBorder(i);
            var key = "colWidth-".concat(i);
            var col = react_1.default.createElement("col", { style: { width: "".concat(width, "%") }, key: key });
            columns.push(col);
        }
        return columns;
    };
    TableWidget.prototype.getColumnBorder = function (idx) {
        if (this.resizeColumnIndex != null) {
            return this.columnBorders[idx];
        }
        return this.props.columnBorders[idx];
    };
    TableWidget.prototype.renderSizeModifiers = function () {
        var resizers = [];
        for (var border = 1; border < this.columns; border++) {
            var percentage = this.getColumnBorder(border);
            var position = "calc(".concat(percentage, "% - 4.5px)");
            var className = "table-widget__column-resizer";
            if (this.resizeColumnIndex == border) {
                className += " ".concat(className, "--resizing");
            }
            var key = "border-".concat(border);
            resizers.push(react_1.default.createElement("div", { key: key, className: className, style: { left: position }, onMouseDown: this.startResizingColumn(border) }));
        }
        return resizers;
    };
    TableWidget.prototype.renderWholeTableToolbar = function () {
        var _this = this;
        var container = this.props.widgetToolbarHost.current;
        if (!this.readyToRenderWholeToolbar || !container) {
            return;
        }
        return react_dom_1.default.createPortal(react_1.default.createElement(WidgetToolbarPositioning_1.WidgetToolbarPositioning, { widgetRef: this.props.attributes.ref, offset: 24 }, function (_a) {
            var _b, _c;
            var toolbarPosition = _a.toolbarPosition, toolbarRef = _a.toolbarRef;
            return (react_1.default.createElement(TableWidgetToolbar_1.TableToolbar, __assign({ topPosition: "".concat((_b = toolbarPosition === null || toolbarPosition === void 0 ? void 0 : toolbarPosition.overlay.top) !== null && _b !== void 0 ? _b : 0, "px"), leftPosition: "".concat((_c = toolbarPosition === null || toolbarPosition === void 0 ? void 0 : toolbarPosition.overlay.left) !== null && _c !== void 0 ? _c : 0, "px"), onDelete: _this.deleteTable, onMouseEnterDelete: _this.startHoveringOnDelete, onMouseLeaveDelete: _this.stopHoveringOnDelete, reselectText: _this.reselectText, toolbarRef: toolbarRef, toolbarType: TableWidgetToolbar_1.TableWidgetToolbarType.WholeTable, allowContextualStyling: _this.allowContextualStyling }, _this.getTcdcToolbarProps())));
        }), container);
    };
    TableWidget.prototype.renderTableToolbar = function () {
        if (!this.tableElem) {
            return react_1.default.createElement("span", null);
        }
        if (this.props.toolbarBeingUsed) {
            return this.renderWholeTableToolbar();
        }
        if (!this.hasSelectedCells()) {
            return react_1.default.createElement("span", null);
        }
        var selectedColumns = this.selectionManager.getSelectedColumns(this.props.selection.selectedCells, this.props.rows, this.props.columns);
        if (selectedColumns.length == this.props.columns) {
            return this.renderWholeTableToolbar();
        }
        return react_1.default.createElement("span", null);
    };
    TableWidget.prototype.renderSelector = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)([
                "table-widget__selector",
                {
                    "table-widget__selector--selected": this.selectionManager.areAllCellsSelected(),
                },
            ]), onMouseDown: function (event) {
                event.preventDefault();
                if (_this.selectionManager.areAllCellsSelected()) {
                    _this.selectionManager.deselect();
                }
                else {
                    _this.selectionManager.selectAllCells();
                }
            } }));
    };
    TableWidget.prototype.addColumn = function (columnIdx) {
        var _this = this;
        return function () {
            var newColumnBorders = TableColumnManager.addColumn(columnIdx, _this.props.columnBorders);
            newColumnBorders = TableColumnManager.normalizeColumnBorders(_this.props.columns + 1, newColumnBorders);
            (0, mobx_1.runInAction)(function () {
                _this.columns = _this.props.columns + 1;
                _this.columnBorders = newColumnBorders;
            });
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.AddColumn,
                path: _this.props.widgetManager.getPath(_this.props.element),
                column: columnIdx,
                columnBorders: lodash_1.default.cloneDeep(newColumnBorders),
            }));
        };
    };
    TableWidget.prototype.deleteColumns = function (columnIdxs) {
        var _this = this;
        return function () {
            var e_1, _a;
            var newColumnBorders = _this.props.columnBorders;
            try {
                for (var columnIdxs_1 = __values(columnIdxs), columnIdxs_1_1 = columnIdxs_1.next(); !columnIdxs_1_1.done; columnIdxs_1_1 = columnIdxs_1.next()) {
                    var columnIdx = columnIdxs_1_1.value;
                    newColumnBorders = TableColumnManager.removeColumn(columnIdx, newColumnBorders);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (columnIdxs_1_1 && !columnIdxs_1_1.done && (_a = columnIdxs_1.return)) _a.call(columnIdxs_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            newColumnBorders = TableColumnManager.normalizeColumnBorders(_this.props.columns - columnIdxs.length, newColumnBorders);
            (0, mobx_1.runInAction)(function () {
                _this.columns = _this.props.columns - columnIdxs.length;
                _this.columnBorders = newColumnBorders;
                _this.isHoveringOnDelete = false;
            });
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.DeleteColumns,
                path: _this.props.widgetManager.getPath(_this.props.element),
                columns: columnIdxs,
                columnBorders: lodash_1.default.cloneDeep(newColumnBorders),
            }));
        };
    };
    TableWidget.prototype.addRow = function (rowIdx, direction) {
        var _this = this;
        return function () {
            (0, mobx_1.runInAction)(function () {
                _this.rows = _this.props.rows + 1;
            });
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.AddRow,
                path: _this.props.widgetManager.getPath(_this.props.element),
                row: rowIdx,
                direction: direction,
            }));
        };
    };
    TableWidget.prototype.addRepeatingRow = function (rowIdx, direction) {
        var _this = this;
        if (direction === void 0) { direction = "below"; }
        return function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.AddRepeatingRow,
                path: _this.props.widgetManager.getPath(_this.props.element),
                row: rowIdx,
                direction: direction,
            }));
        };
    };
    TableWidget.prototype.deleteRows = function (rowIdxs) {
        var _this = this;
        return function () {
            (0, mobx_1.runInAction)(function () {
                _this.rows = _this.props.rows - rowIdxs.length;
                _this.isHoveringOnDelete = false;
            });
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.DeleteRows,
                path: _this.props.widgetManager.getPath(_this.props.element),
                rows: rowIdxs,
            }));
        };
    };
    TableWidget.prototype.getTcdcToolbarProps = function () {
        var _a = this.props, usingFeature = _a.usingFeature, blockStore = _a.blockStore, brandStore = _a.brandStore, stylePermissionStore = _a.stylePermissionStore;
        if ((0, FeatureFlag_1.isUsingTCDC)(usingFeature)) {
            return {
                usingTCDC: true,
                blockStore: blockStore,
                brandStore: brandStore,
                stylePermissionStore: stylePermissionStore,
            };
        }
        return {};
    };
    Object.defineProperty(TableWidget.prototype, "allowContextualStyling", {
        get: function () {
            return this.props.editorSchemaName !== AgreementSchema_1.schema.name;
        },
        enumerable: false,
        configurable: true
    });
    TableWidget.maxColumns = 20;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], TableWidget.prototype, "rows", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], TableWidget.prototype, "columns", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Array)
    ], TableWidget.prototype, "columnBorders", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TableWidget.prototype, "resizeColumnIndex", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], TableWidget.prototype, "isHoveringOnDelete", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TableWidget.prototype, "readyToRenderWholeToolbar", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], TableWidget.prototype, "hoveredColumnForDeletionIdx", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TableWidget.prototype, "resizeColumn", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TableWidget.prototype, "stopResizing", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TableWidget.prototype, "startHoveringOnDelete", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TableWidget.prototype, "stopHoveringOnDelete", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TableWidget.prototype, "allowContextualStyling", null);
    TableWidget = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], TableWidget);
    return TableWidget;
}(react_1.default.Component));
exports.default = TableWidget;
